import request from 'crm/utils/request'
import {format} from 'utils'
import api from 'crm/common/api/group-sop'
import {stringify} from 'qs'

export async function tasks(params) {
    return request(`${api.tasks.url}?${stringify(params)}`)
}

export async function tasksChats(params) {
    return request(`${format(api.tasksChats.url, {task_id: params.task_id})}?${stringify(params)}`)
}

export async function tasksDelete(payload = {}) {
    return request(`${format(api.tasksDelete.url, {task_id: payload.task_id})}`, {
        method: api.tasksDelete.type,
        body: payload.body,
    })
}

export async function tasksChatsDelete(payload = {}) {
    return request(
        `${format(api.tasksChatsDelete.url, {task_id: payload.task_id, chat_id: payload.chat_id})}`,
        {
            method: api.tasksChatsDelete.type,
            body: payload.body,
        },
    )
}

export async function tasksStatusModify(payload = {}) {
    return request(`${format(api.tasksStatusModify.url, {task_id: payload.task_id})}`, {
        method: api.tasksStatusModify.type,
        body: payload.body,
    })
}

export async function createTasksChats(payload = {}) {
    return request(`${format(api.createTasksChats.url, {task_id: payload.task_id})}`, {
        method: api.createTasksChats.type,
        body: payload.body,
    })
}
